import { render } from "./SettingsPage.vue?vue&type=template&id=1025a19c&scoped=true"
import script from "./SettingsPage.vue?vue&type=script&lang=js"
export * from "./SettingsPage.vue?vue&type=script&lang=js"

import "./SettingsPage.vue?vue&type=style&index=0&id=1025a19c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1025a19c"],['__file',"src/components/NavigationBarComponents/SettingsPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1025a19c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1025a19c', __exports__)) {
    api.reload('1025a19c', __exports__)
  }
  
  module.hot.accept("./SettingsPage.vue?vue&type=template&id=1025a19c&scoped=true", () => {
    api.rerender('1025a19c', render)
  })

}


export default __exports__